// extracted by mini-css-extract-plugin
export default {"PasswordResetEmailForm__submit":"zm_a bik_ql bik_tq"};